import axios from 'axios';
import {
  AccommodationAttributeQueryFilters,
  AddBuildingRoomBedItem,
  BuildingRoomsQueryFilters,
  BuildingUpdateData,
  RemoveBuildingRoomBedItem,
  RoomsAndAreasFilter,
  UpdateAttributeIndexCommand,
  UpdateBuildingRoomAreaItem,
  UpdateBuildingRoomBedItem,
  UpdateBuildingRoomItem,
} from '../../features/accommodations/accommodationAttributesSlice';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  AccommodationAttribute,
  AttributeGroupOptions,
} from '../../features/searchBookableAccommodations/attributesSlice';
import { LOCALES } from '../constants';

export function fetchAllBuildingRooms(
  filterRequest: BuildingRoomsQueryFilters,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post(
      '/accommodation/buildingrooms/getallbuildingrooms',
      filterRequest,
      config,
    )
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAllAccommodationBuildings(
  filterRequest: BuildingRoomsQueryFilters,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post(
      '/accommodation/buildingrooms/getallaccommodationbuildings',
      filterRequest,
      config,
    )
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAllRoomAreas(filterRequest: RoomsAndAreasFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post('/accommodation/buildingrooms/getallroomareas', filterRequest, config)
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAllBeds(filterRequest: RoomsAndAreasFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post('/accommodation/buildingrooms/getallbeds', filterRequest, config)
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAllRooms(filterRequest: RoomsAndAreasFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post('/accommodation/buildingrooms/getallrooms', filterRequest, config)
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAllBuildngs(filterRequest: RoomsAndAreasFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post('/accommodation/buildingrooms/getallbuildings', filterRequest, config)
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAllFloors(filterRequest: RoomsAndAreasFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post('/accommodation/buildingrooms/getallfloors', filterRequest, config)
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}
export function fetchAllBuildingRoomAreas(
  filterRequest: BuildingRoomsQueryFilters,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post(
      '/accommodation/buildingrooms/getallbuildingroomareas',
      filterRequest,
      config,
    )
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAllAccommodationAttributes(
  filterRequest: AccommodationAttributeQueryFilters,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post(
      '/accommodation/accommodationattributes/getAllAccommodationAttributes',
      filterRequest,
      config,
    )
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAccommodationAttributeDetails(accommodationAttributeId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationAttributeId },
  };

  return axios
    .get(
      '/accommodation/accommodationattributes/getAccommodationAttributeDetails',
      config,
    )
    .then(res => {
      return res.data;
    });
}
export function fetchAccommodationOwnerDetails(accommodationAttributeId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationAttributeId },
  };

  return axios
    .get(
      '/accommodation/accommodationattributes/getAccommodationOwnerDetails',
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function fetchAttributeTypes(
  filterRequest: AccommodationAttributeQueryFilters,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post(
      '/accommodation/accommodationattributes/getAttributeTypes',
      filterRequest,
      config,
    )
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAccommodationAttributeOptions(accommodationAttributeId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationAttributeId },
  };

  return axios
    .get(
      '/accommodation/accommodationattributes/getAccommodationAttributeOptions',
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateAccommodationAttribute(accommodationAttributeData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/accommodationattributes/updateaccommodationattribute',
      accommodationAttributeData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateBuildingRoomBed(roomBedData: UpdateBuildingRoomBedItem) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/buildingrooms/updatebuildingroombed',
      roomBedData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateBuilding(buildingData: BuildingUpdateData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/accommodation/buildingrooms/updatebuilding', buildingData, config)
    .then(res => {
      return res.data;
    });
}

export function addBuildingRoomBed(roomBedData: AddBuildingRoomBedItem) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/buildingrooms/addbuildingroombed',
      roomBedData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function removeBuildingRoomBed(roomBedData: RemoveBuildingRoomBedItem) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/buildingrooms/removebuildingroombed',
      roomBedData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateBuildingRoom(roomBedData: UpdateBuildingRoomItem) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/buildingrooms/updatebuildingroom',
      roomBedData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateBuildingRoomArea(
  roomBedData: UpdateBuildingRoomAreaItem,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/buildingrooms/updatebuildingroomarea',
      roomBedData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateAttributeIndexes(
  AttributeIndexesData: UpdateAttributeIndexCommand,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/accommodationattributes/updateattributeindexes',
      AttributeIndexesData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function addBuildingRoomArea(buildingRoomArea) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/accommodationattributes/addbuildingroomarea',
      buildingRoomArea,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function addBuilding(building) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/accommodationattributes/addbuilding',
      building,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function addBuildingRoom(buildingRoom) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/accommodationattributes/addbuildingroom',
      buildingRoom,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function removeBuildingRoom(buildingRoom) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/accommodationattributes/removebuildingroom',
      buildingRoom,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function removeBuilding(buildingRoom) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/accommodationattributes/removebuilding',
      buildingRoom,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function removeBuildingRoomArea(buildingRoomArea) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/accommodationattributes/removebuildingroomarea',
      buildingRoomArea,
      config,
    )
    .then(res => {
      return res.data;
    });
}
export function addAccommodationAttributeData(accommodationAttributeData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/accommodationattributes/addAccommodationAttribute',
      accommodationAttributeData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export const getAccommodationAttributesByGroup = async (
  group: AttributeGroupOptions,
  locale: LOCALES,
): Promise<AccommodationAttribute[]> => {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { group, cultureOption: locale },
  };

  try {
    const response = await axios.get<AccommodationAttribute[]>(
      `/accommodation/accommodationattributes/getAccommodationAttributesByGroup`,
      config,
    );
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch accommodation attributes by group');
  }
};
